import React from "react";
import { motion } from "framer-motion";
import { CandyOffIcon, MilkOffIcon, StarIcon, WheatOffIcon, DownloadIcon } from "lucide-react";
import { CtaButton } from "../ui/CtaButton";
import { Polaroid } from "../ui/Polaroid";
import { desserts, mockupUrl, people } from "../../data/images";
import { EASE_OUT } from "../../utils/motion";
const filters = [{
  icon: CandyOffIcon,
  label: "Sin azúcar refinada"
}, {
  icon: WheatOffIcon,
  label: "Sin gluten"
}, {
  icon: MilkOffIcon,
  label: "Sin lactosa"
}];
export function Hero() {
  return <header className="relative overflow-hidden bg-cream" data-id="element-195" data-mp="qtt1hd5jcg4q">
      <div className="mx-auto max-w-6xl px-5 pb-16 pt-10 text-center lg:pt-14" data-id="element-196" data-mp="vm2l6bg24jyk">
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE_OUT
      }} className="mx-auto mb-6 flex w-fit items-center gap-3" data-id="element-197" data-mp="10l5onrge2i4f">
          <div className="flex -space-x-2" data-id="element-198" data-mp="1akeimkb97wqs">
            {[people.lucia, people.marta, people.elena, people.patricia].map(src => <img key={src} src={src} alt="" className="h-8 w-8 rounded-full object-cover ring-2 ring-cream" data-id="element-199" data-mp="9lg90vc1oys6" />)}
          </div>
          <div className="text-left" data-id="element-200" data-mp="3vu951c65s4gs">
            <div className="flex gap-0.5" aria-label="5 estrellas" data-id="element-201" data-mp="3vvaq89gw27c8">
              {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-3.5 w-3.5 fill-gold text-gold" data-id="element-202" data-mp="seaorrhhsuxg" data-mpi={i} />)}
            </div>
            <p className="text-xs font-semibold text-cocoa-light" data-id="element-203" data-mp="nfhcu3hutbze">+2,000 mujeres en Latam, España y USA</p>
          </div>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE_OUT,
        delay: 0.05
      }} className="mx-auto max-w-5xl font-display text-[1.75rem] font-bold leading-[1.2] text-cocoa sm:text-4xl lg:text-[2.85rem]" data-id="element-204" data-mp="imxxb0zlw6ry">
          Cómo Disfrutar de Postres Gourmet <span className="text-berry" data-id="element-205" data-mp="30m7747jd1075">"Triple Filtro"</span> en{" "}
          <span className="relative whitespace-nowrap" data-id="element-206" data-mp="30o0e5nxvxmfo">
            <span className="relative z-10" data-id="element-207" data-mp="35jyx2w0g2c8p">Menos de 20 Minutos</span>
            <motion.span aria-hidden className="absolute inset-x-0 bottom-1 -z-0 h-3 origin-left bg-gold-light/70" initial={{
            scaleX: 0
          }} animate={{
            scaleX: 1
          }} transition={{
            duration: 0.3,
            delay: 0.35,
            ease: EASE_OUT
          }} data-id="element-208" data-mp="2qwdur4be8h1u" />
          </span>
          , Sin Inflamar tu Cuerpo y Sin Gastar una Fortuna en Ingredientes Raros{" "}
          <span className="font-medium italic text-cocoa-light" data-id="element-209" data-mp="27xrshm454jwc">
            — Incluso Si Sientes Que Has Fallado Con Cada Receta "Saludable" Que Has Intentado Antes.
          </span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE_OUT,
        delay: 0.12
      }} className="mx-auto mt-6 max-w-3xl text-lg leading-relaxed text-cocoa-light sm:text-xl" data-id="element-210" data-mp="65dgt4s6wbod">
          El primer sistema de pastelería saludable diseñado específicamente para mujeres que quieren{" "}
          <b className="text-cocoa" data-id="element-211" data-mp="25ck3ch4sqqkc">transformar su relación con el dulce</b>, eliminar los antojos de la tarde y ver resultados en su digestión
          desde la primera semana.
        </motion.p>

        <div className="relative mx-auto mt-12 max-w-3xl" data-id="element-212" data-mp="2ed8ft7ejkiv4">
          <Polaroid src={desserts.swirlBars} label="Sin hornear" rotate={-8} className="absolute -left-36 top-6 hidden w-40 lg:block" delay={0.2} data-id="element-213" data-mp="2ebp0pk4mgdux" />
          <Polaroid src={desserts.roseCupcakes} label="Muffins" rotate={6} className="absolute -left-28 bottom-10 hidden w-36 lg:block" delay={0.8} data-id="element-214" data-mp="2oc7sr26cb0nx" />
          <Polaroid src={desserts.homemadeOreos} label="Cookies" rotate={7} className="absolute -right-36 top-2 hidden w-40 lg:block" delay={0.5} data-id="element-215" data-mp="2jdebqzrugrj0" />
          <Polaroid src={desserts.chocolateDonut} label="Para niños" rotate={-6} className="absolute -right-28 bottom-14 hidden w-36 lg:block" delay={1.1} data-id="element-216" data-mp="oz3mwrb91xd8" />

          <motion.div initial={{
          opacity: 0,
          scale: 0.96
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.3,
          ease: EASE_OUT,
          delay: 0.15
        }} className="relative" data-id="element-217" data-mp="qhtwhvxbjctr">
            <motion.img src={mockupUrl} alt="Pack Dulce Saludable: caja con 7 recetarios digitales y membresía de actualización" className="relative z-10 w-full rounded-[2rem] border-[10px] border-white shadow-[0_40px_80px_-30px_rgba(59,34,25,0.55)]" animate={{
            y: [0, -8, 0]
          }} transition={{
            duration: 6,
            repeat: Infinity,
            ease: "easeInOut"
          }} data-id="element-218" data-mp="15cqf932r7il3" />
            <div className="absolute -bottom-5 left-1/2 z-20 flex -translate-x-1/2 items-center gap-2 whitespace-nowrap rounded-full bg-cocoa px-4 py-2 text-xs font-bold text-cream shadow-lg sm:text-sm" data-id="element-219" data-mp="mf78k63rqc1u">
              <DownloadIcon className="h-4 w-4 text-gold-light" data-id="element-220" data-mp="3q1xvictboe2p" />
              Producto 100% digital · Descarga directa
            </div>
          </motion.div>
        </div>

        <ul className="mx-auto mt-12 flex max-w-2xl flex-wrap justify-center gap-3" data-id="element-221" data-mp="2369htipq5iq9">
          {filters.map(({
          icon: Icon,
          label
        }, i) => <motion.li key={label} initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          delay: 0.3 + i * 0.06,
          ease: EASE_OUT
        }} className="flex items-center gap-2 rounded-full border border-blush-dark bg-white px-4 py-2 text-sm font-semibold text-cocoa shadow-sm" data-id="element-222" data-mp="1y5lhu7jiprjw" data-mpi={i}>
              <Icon className="h-4 w-4 text-berry" data-id="element-223" data-mp="1fhggf6qc2io9" />
              {label}
            </motion.li>)}
        </ul>

        <div className="mx-auto mt-8 max-w-xl" data-id="element-224" data-mp="1afr7pxql2h3c">
          <CtaButton href="#oferta" label="Quiero mi Pack Dulce Saludable" sublabel="Acceso inmediato · Garantía de 30 días" data-id="element-225" data-mp="15j0stdqilrji" />
        </div>
      </div>
    </header>;
}